<template>
  <div class="main_wrap">
    <!-- 活动标题 -->
    <div v-wechat-title="'《魔卡少女樱：回忆钥匙》摇一摇领奖'"></div>

    <Header
      v-if="true"
      :isOnline="0"
      :isShake="true"
      :config="headerConfig"
      :isShowInfo="true"
    />

    <div class="first-page">
      <div class="rules_btn" @click="isShowRules = true"></div>
      <div class="get_btn" @click="getRequest"></div>
      <div class="tips"></div>
    </div>
    <div class="second-page"></div>
    <Footer :gameName="gameName"></Footer>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
      @getSelectInfo="getSelectInfo"
    ></Os>

    <!-- 领奖弹窗 -->
    <div class="dialog-bg-wrap popup_wrap" v-show="isShow">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="dialog-bg-box popup_wrap-box" v-show="isShow">
          <div class="prize">
            <div class="btn" @click="getAward"></div>
          </div>
          <div class="close" @click="isShow = false"></div>
          <div class="close-bg" @click="isShow = false"></div>
        </div>
      </transition>
    </div>

    <!-- 没有奖品弹窗 -->
    <div class="nothing-wrap popup_wrap" v-show="isShowNothing">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="nothing-box popup_wrap-box" v-show="isShowNothing">
          <div class="affirm" @click="isShowNothing = false"></div>
          <div class="close" @click="isShowNothing = false"></div>
          <div class="close-bg" @click="isShowNothing = false"></div>
        </div>
      </transition>
    </div>

    <!-- 登记信息弹窗 -->
    <div class="address-wrap popup_wrap" v-show="isShowAddress">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="address-box popup_wrap-box" v-show="isShowAddress">
          <div class="area1_class">
            <input
              type="text"
              v-model="area1"
              placeholder="请输入详细收货地址"
            />
          </div>
          <div class="area2_class">
            <input type="text" v-model="area2" placeholder="请输入输入门牌号" />
          </div>
          <div class="name_class">
            <input type="text" v-model="name" placeholder="请输入联系人" />
          </div>
          <div class="phone_class">
            <input type="text" v-model="phone" placeholder="请输入手机号" />
          </div>
          <div class="cancel" @click="closeAddress"></div>
          <div class="affirm" @click="registerSuccess"></div>
          <div class="close" @click="closeAddress"></div>
          <div class="close-bg" @click="closeAddress"></div>
        </div>
      </transition>
    </div>

    <!-- 信息登记成功弹窗 -->
    <div class="success-wrap popup_wrap" v-show="isShowSuccess">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="success-box popup_wrap-box" v-show="isShowSuccess">
          <div class="affirm" @click="isShowSuccess = false"></div>
          <div class="close" @click="isShowSuccess = false"></div>
          <div class="close-bg" @click="isShowSuccess = false"></div>
        </div>
      </transition>
    </div>

    <!-- 活动规则弹窗 -->
    <div class="rules-wrap popup_wrap" v-show="isShowRules">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="rules-box popup_wrap-box" v-show="isShowRules">
          <div class="rules_detail_wrap">
            <img
              src="https://download4.qcplay.com/h5-images/active/sakura/shake/rules_detail.png"
              alt=""
            />
          </div>
          <div class="close" @click="isShowRules = false"></div>
          <div class="close-bg" @click="isShowRules = false"></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { onGetInitDataAPI, submitInfoApi, secretFreeLoginApi } from "../api";
import { buriedLogger } from "@/utils/utils";

export default {
  name: "sakura-shake",
  components: {
    Header,
    Footer,
    Login,
    Os
  },

  data() {
    return {
      headerConfig,
      gameName: "sakura",
      downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
      isShow: false, // 领奖弹窗
      isShowNothing: false, // 没有奖品弹窗
      isShowAddress: true, // 登记信息弹窗
      isShowSuccess: false, // 登记成功弹窗
      isShowRules: false, // 活动规则弹窗
      // 其他数据
      loginTypes: ["sms", "password"],
      // 收货地址
      area1: "",
      // 门牌号
      area2: "",
      // 联系人
      name: "",
      // 手机号
      phone: "",
      // 游戏传过来的参数↓
      game_id: "",
      role_id: "",
      sign: "",
      token: "",
      // 游戏传过来的参数↑
      // 角色是否中奖
      is_reward: "0"
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    if (
      this.$route.query.game_id &&
      this.$route.query.role_id &&
      this.$route.query.token
    ) {
      this.game_id = this.$route.query.game_id;
      this.role_id = this.$route.query.role_id;
      this.sign = this.$route.query.sign;
      this.token = this.$route.query.token;
      this.secretFreeLogin();
    } else {
      this.initData();
    }

    // 埋点
    const bl = buriedLogger("sakura", "摇一摇领奖");
    this.logger = bl;
  },
  mounted() {},
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.is_reward = "0";
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
        }
      }
    }
  },
  methods: {
    // 初始化接口
    initData() {
      onGetInitDataAPI().then(response => {
        this.is_reward = response.data.activity.is_reward;
        this.onInitDataCallback(response);
        this.setUserInfo(response.data.userinfo);
        this.setActiveInfo(response.data.activity);
      });
    },
    // 提交信息接口请求
    submitInfo() {
      let params = {
        name: this.name,
        phone: this.phone,
        address: this.area1 + this.area2
      };
      submitInfoApi(params).then(response => {
        if (response.code == 200) {
          this.isShowAddress = false;
          this.isShowSuccess = true;
          this.initData();
          this.logger.sum("信息登记成功");
        } else {
          this.logger.sum("信息登记成功");
          this.onToast(response.message);
        }
      });
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        game_id: this.game_id,
        role_id: this.role_id,
        sign: this.sign,
        token: this.token
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          this.initData();
          this.logger.sum("免密登录成功");
        } else {
          this.logger.sum("免密登录失败");
          this.onToast(response.message);
        }
      });
    },
    // 点击立即领取
    getRequest() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      } else if (this.is_reward != 1) {
        return (this.isShowNothing = true);
      }
      this.isShow = true;
    },
    //领奖成功弹窗
    closeDialog() {
      this.isShow = false;
    },
    // 领取奖励
    getAward() {
      this.isShow = false;
      if (!this.activeInfo.name) {
        this.isShowAddress = true;
      } else {
        this.isShowSuccess = true;
      }
    },
    // 登记信息确定操作
    registerSuccess() {
      if (!this.area1) {
        this.onToast("请输入详细收货地址！");
      } else if (!this.area2) {
        this.onToast("请输入输入门牌号！");
      } else if (!this.name) {
        this.onToast("请输入联系人！");
      } else if (!this.phone) {
        this.onToast("请输入手机号！");
      } else {
        this.submitInfo();
      }
    },
    // 关闭登记信息弹窗
    closeAddress() {
      this.area1 = "";
      this.area2 = "";
      this.name = "";
      this.phone = "";
      this.isShowAddress = false;
    },
    // 获取选中的角色信息
    getSelectInfo(info, token) {
      this.token = token;
    },
    // 选择角色后
    selectCallback() {
      this.initData();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {},
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
      "setUserInfo",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/shake/index/index.vue